export default __webpack_public_path__ + "static/checknlearn-promo@1x-9d874343bd5435cc83d34f979b519821.jpg";